/*
 * Authors: mariushirjanu
 * Created: 02/09/2021
 */
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { STATE_PAYMENT, STATE_PAYMENT_INVOICE, STATE_PAYMENT_ORDER } from '@app/shared/app-states';
import { PaymentComponent } from './payment.component';
import { OrderPaymentComponent } from './order-payment.component';
import { InvoicePaymentComponent } from './invoice-payment.component';
import { PaymentFormattingService } from './payment-formatting.service';
import { PaymentDataService } from './payment-data.service';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { Lang } from '@app/shared/language/language-data.service';
import { PaymentMatcherDataService } from './payment-matcher/payment-matcher-data.service';
import { PaymentMatcherDialogComponent } from './payment-matcher/payment-matcher-dialog.component';
import { PaymentListMatchesComponent } from './payment-matcher/payment-list-matches.component';
import { PaymentListInvoicesComponent } from './payment-matcher/payment-list-invoices.component';
import { PaymentTransactionDetailsComponent } from './payment-matcher/payment-transaction-details.component';
import { PaymentMatcherService } from './payment-matcher/payment-matcher.service';
import { PaymentListMatchesAmountsComponent } from './payment-matcher/payment-list-matches-amounts.component';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

export const states:GaStateDeclaration[] = [
  {
    name: STATE_PAYMENT,
    url: '/payment',
    abstract: true,
    views: {
      content: {
        component: PaymentComponent
      }
    },
    data: {
      translate: true,
      modules: [ TranslationCategory.ORDERENTRY ] // load orderentry translations
    },
    resolve: [
      {
        token: 'companyCountryId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().companyCountryId)
      }
    ]
  },
  {
    name: STATE_PAYMENT_ORDER,
    url: '?order',
    component: OrderPaymentComponent,
    data: {
      viewTitle: 'Order Payment'
    },
    resolve: [
      {
        token: 'order',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().order)
      },
      TRANSLATION_READY_RESOLVER
    ]
  },
  {
    name: STATE_PAYMENT_INVOICE,
    url: '?invoice',
    data: {
      viewTitle: 'Invoice Payment',
      translate: true,
      languages: [ Lang.DE ]
    },
    component: InvoicePaymentComponent,
    bindings: {
      order: 'invoice'
    },
    resolve: [
      {
        token: 'invoice',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().invoice)
      },
      TRANSLATION_READY_RESOLVER
    ]
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  declarations: [
    PaymentComponent,
    OrderPaymentComponent,
    InvoicePaymentComponent,
    PaymentMatcherDialogComponent,
    PaymentListMatchesComponent,
    PaymentListMatchesAmountsComponent,
    PaymentListInvoicesComponent,
    PaymentTransactionDetailsComponent
  ],
  providers: [
    PaymentDataService,
    PaymentFormattingService,
    PaymentMatcherDataService,
    PaymentMatcherService
  ]
})
export class PaymentModule { }

